
import React, {Component} from 'react';
import { Wrapper, MegagonLogo, PubLink, Contact, ElementsContainer} from '../styles/banner_styles';
import BannerLogo from '../images/color_logo_transparent_snippext_api.png';

class Banner extends Component{

  onBannerClick(){
      window.open("https://www.megagon.ai/", "_blank")
  }

  render(){

    return(
      <Wrapper data-tut="banner">
        <ElementsContainer>
          <MegagonLogo src={BannerLogo} onClick={this.onBannerClick}/>
          <PubLink href="https://megagon.ai/publications/#SnippextPaper" target="_blank"> PUBLICATIONS
          </PubLink>
          <Contact href= "https://megagon.ai/contact/" target="_blank"> CONTACT US </Contact>
        </ElementsContainer>
      </Wrapper>
    )
  }

 }

export default Banner;
